import { BellRing } from 'lucide-react';
import AvisosProactivos from '../integraciones/AvisosProactivos';

/* =====================================================================
   Las pantallas del carril `integraciones` · DESPEGUE F7
   =====================================================================
   «Avisos que piensan» va en Control, junto a las reglas de
   autorización: es donde una empresa decide de qué se le avisa y a
   partir de cuánto. Lo ve un encargado; lo cambia un administrador.
   ===================================================================== */
export default {
  orden: 65,
  grupos: [{
    grupo: 'Control',
    items: [
      { id: 'avisos-proactivos', etiqueta: 'Avisos automáticos', icono: BellRing, min: 'ENCARGADO', Comp: AvisosProactivos },
    ],
  }],
};
